// Navbar.jsx
import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import MenuIcon from "@mui/icons-material/Menu";
import { Link as RouterLink, useLocation } from "react-router-dom";
import logo from "../Assets/Images/logo.png";

const navItems = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Contact", to: "/contact" },
  // { label: "Elements", to: "/elements" },
];

export default function Navbar() {
  const location = useLocation();
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = () => setOpen((prev) => !prev);

  const isActive = (path) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#ffffff",
        color: "text.primary",
        borderBottom: "1px solid rgba(0,0,0,0.04)",
      }}
    >
      <Toolbar
        sx={{
          width: "100%",
          minHeight: 86,
          px: { xs: 2, md: 4 },
        }}
      >
        {/* LEFT: LOGO */}
        <Box
          component={RouterLink}
          to="/"
          sx={{
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
          }}
        >
          <Box
            component="img"
            src={logo}
            alt="Company Logo"
            sx={{
              height: { xs: 55, md: 75 },
              width: "auto",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Box>

        {/* CENTER: NAV LINKS (DESKTOP) */}
        <Box
          sx={{
            flex: 1,
            display: { xs: "none", md: "flex" },
            justifyContent: "center",
            gap: 3.5,
          }}
        >
          {navItems.map((item) => (
            <Box
              key={item.to}
              sx={{ position: "relative", display: "flex" }}
            >
              <Button
                component={RouterLink}
                to={item.to}
                disableRipple
                sx={{
                  textTransform: "none",
                  fontWeight: isActive(item.to) ? 600 : 500,
                  fontSize: 15,
                  color: isActive(item.to) ? "#111827" : "#4b5563",
                  px: 0,
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "#111827",
                  },
                }}
              >
                {item.label}
              </Button>

              {isActive(item.to) && (
                <Box
                  sx={{
                    position: "absolute",
                    left: "50%",
                    bottom: -6,
                    transform: "translateX(-50%)",
                    width: 30,
                    height: 3,
                    borderRadius: 999,
                    backgroundColor: "#ff8a00",
                  }}
                />
              )}
            </Box>
          ))}
        </Box>

        {/* RIGHT: PHONE (DESKTOP) */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            gap: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                backgroundColor: "#ff8a00",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                boxShadow: "0 10px 25px rgba(255,138,0,0.45)",
              }}
            >
              <PhoneIcon fontSize="small" />
            </Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: 600, whiteSpace: "nowrap" }}
            >
              +1 (888) 835-2473
            </Typography>
          </Box>
        </Box>

        {/* MOBILE MENU ICON */}
        <IconButton
          edge="end"
          sx={{ display: { xs: "inline-flex", md: "none" }, ml: "auto" }}
          onClick={toggleDrawer}
        >
          <MenuIcon />
        </IconButton>

        {/* MOBILE DRAWER */}
        <Drawer anchor="right" open={open} onClose={toggleDrawer}>
          <Box sx={{ width: 260, mt: 8 }}>
            <List>
              {navItems.map((item) => (
                <ListItemButton
                  key={item.to}
                  component={RouterLink}
                  to={item.to}
                  selected={isActive(item.to)}
                  onClick={toggleDrawer}
                >
                  <ListItemText primary={item.label} />
                </ListItemButton>
              ))}
            </List>
          </Box>
        </Drawer>
      </Toolbar>
    </AppBar>
  );
}
